import { useDirection, useSiteContext, useTranslation } from '@eti/providers';
import { Link } from 'react-router-dom';
import { Pictogram } from '@eti/components';
import { getProductPictogramId, ONLINE_CHECK_IN, productIds } from '@eti/products';
import {
  breakpoints,
  Button,
  Card,
  Heading,
  Inline,
  Stack,
  Text,
  textVariants,
  vars,
} from '@etg/wings';
import { css } from '@eti/styles';
import { Sparkle } from '@phosphor-icons/react';
import { routes } from '../../../../../constants/routesAndApisConstants';
import CheckListItems from '../../common/CheckListItems';

const stackStyles = css`
  flex: 1;
`;

const subTitleStyles = css`
  color: ${vars.colors.promotional.dark};
`;

const CheckInPromotionalBanner = () => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const isRTL = useDirection();

  return (
    <Card data-testid="check-in-promotional-banner">
      <Inline collapseBelow={breakpoints._560}>
        <Pictogram
          aria-hidden="true"
          brand={brand.code}
          data-testid="check-in-promotional-banner-icon"
          id={getProductPictogramId(productIds[Number(ONLINE_CHECK_IN.id)], isRTL)}
          size="4rem"
        />
        <Stack className={stackStyles}>
          <Heading data-testid="check-in-promotional-banner-title" level={2}>
            {t('CheckIn.Banner.Title')}
          </Heading>
          <Stack spacing={8}>
            <Inline className={subTitleStyles} noWrap spacing={8}>
              <Sparkle
                aria-hidden="true"
                data-testid="check-in-promotional-banner-subtitle-icon"
                mirrored={isRTL}
                size="1.25rem"
                weight="fill"
              />
              <Text
                data-testid="check-in-promotional-banner-subtitle"
                variant={textVariants._14_BOLD}
              >
                {t('CheckIn.Banner.SubTitle')}
              </Text>
            </Inline>
            <CheckListItems
              dataTestId="check-in-promotional-banner"
              htmlTextKey="CheckIn.Banner.Description"
            />
          </Stack>
          <Inline align="end">
            <Button
              as={Link}
              data-testid="check-in-promotional-banner-link"
              to={`${routes.ORDER_DETAILS_EXTRA_PRODUCTS}#product-id-${ONLINE_CHECK_IN.id}`}
              variant="primary"
            >
              {t('CheckIn.Banner.Link.Text')}
            </Button>
          </Inline>
        </Stack>
      </Inline>
    </Card>
  );
};

export default CheckInPromotionalBanner;
